export default "__VITE_ASSET__tr0vftjf__"